import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class MessageFiltersResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "message_filter", `/api/v1/message_filters`);
  }
}
